module.exports = __webpack_public_path__ + "img/zoom_scheduler.da5beb38.svg";